import React from 'react'
import { connect } from 'react-redux'

import { selectLabels } from 'selectors/labels/base'
import { selectTicketSearchTotalCountsByQueryId } from 'selectors/search'

import { sortByKeyTypeDesc } from 'util/arrays'

import Item from './Item'

const TagsView = props => {
  const {
    labels,
    buildMailboxFolderPath,
    buildMailboxQueryString,
    doOpenSearchPage,
    doStartSearchTimer,
  } = props
  if (!labels) return null
  return labels.map(label => {
    return (
      <Item
        labelId={label.id}
        name={label.name}
        key={`label-${label.id}`}
        doOpenSearchPage={doOpenSearchPage}
        doStartSearchTimer={doStartSearchTimer}
        className="label"
        displayCountWhenInactive
        ticketCount={label.ticketCount}
        buildMailboxFolderPath={buildMailboxFolderPath}
        buildMailboxQueryString={buildMailboxQueryString}
      />
    )
  })
}

const selectFactory = (_, initialOwnProps) => {
  const { buildMailboxQueryString } = initialOwnProps

  return state => {
    const labels = selectLabels(state)
    const ticketCounts = selectTicketSearchTotalCountsByQueryId(state)

    const sortedLabels = labels
      .map(label => {
        // We use the ticketCount in two places, so
        // build a new object with that property
        const ticketCount =
          ticketCounts[
            buildMailboxQueryString({
              state: 'opened',
              label: label.id,
            })
          ]
        return { ...label, ticketCount }
      })
      .filter(label => label.ticketCount > 0)
      .sort(sortByKeyTypeDesc('ticketCount', 'number'))
      .map(label => {
        return {
          id: label.id,
          name: label.name,
          ticketCount: label.ticketCount,
        }
      })

    return {
      labels: sortedLabels,
    }
  }
}

const Tags = connect(selectFactory)(TagsView)

export default Tags
